var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNumberField = function SvgNumberField(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.895,
    height: 12.5,
    viewBox: "0 0 14.895 12.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "number-field",
    transform: "translate(-34 -730)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M12.5,19.5H15V7H10V9.5h2.5Z",
    transform: "translate(24 723)",
    fill: "#3c3e69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M-14.625,7.036l.912.906,2.036-2.036,2.036,2.036.906-.906-2.941-2.948Zm5.9,4.1-.912-.906-2.036,2.036-2.036-2.036-.912.906,2.948,2.948Z",
    transform: "translate(57.625 727.161)",
    fill: "#3c3e69"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNumberField, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/number-field.7ec5bf4e.svg";
export { ForwardRef as ReactComponent };